import React, { useState } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Textos acima deste tamanho ficam recolhidos com "Ler mais"
const LIMITE_TEXTO = 140;

/* ======================
   DADOS DOS DEPOIMENTOS
====================== */
const depoimentos = [
  {
    nome: 'S.',
    ano: '2024',
    texto: 'A Elaine é acolhedora e atenciosa, estou conseguindo enxergar minhas emoções de uma forma que eu nunca tinha conseguido antes.',
    rating: 5,
  },
  {
    nome: 'L.',
    ano: '2025',
    texto: 'Sempre tive receio de fazer terapia, mas a condução é leve, respeitosa e acolhedora. Estou gostando muito do processo.',
    rating: 5,
  },
  {
    nome: 'D.',
    ano: '2025',
    texto: 'Sinto que posso falar sobre qualquer assunto sem julgamentos. Isso tem sido muito importante para mim.',
    rating: 5,
  },
  {
    nome: 'A.',
    ano: '2025',
    texto: 'A terapia tem me ajudado a atravessar um momento delicado com mais clareza e equilíbrio emocional.',
    rating: 5,
  },
  {
    nome: 'R.',
    ano: '2024',
    texto: 'Hoje consigo compreender melhor meus sentimentos e tomar decisões com mais segurança.',
    rating: 5,
  },
  {
    nome: 'C.',
    ano: '2025',
    texto: 'Atendimento humano, ético e muito acolhedor. Me senti respeitada desde o início.',
    rating: 5,
  },
  {
    nome: 'E.',
    ano: '2026',
    texto: 'Uma análise completa, aquela que te deixa surpresa. Pois desvenda todos os seus pontos fortes e fracos, revelando aspectos importantes para melhoria e equilíbrio. Amei fazer esta avaliação DISC com a Elaine. É uma profissional competente e transmite muita segurança durante todo o processo.',
    rating: 5,
  },
  {
    nome: 'I.',
    ano: '2026',
    texto: 'Uma profissional incrível! Sempre atenciosa, disposta e pronta para ouvir sobre qualquer problema. A terapia é muito esclarecedora e tem me ajudado a aprender a lidar melhor com meus sentimentos e ansiedade.',
    rating: 5,
  },
  {
    nome: 'R.',
    ano: '2026',
    texto: 'Excelente profissional. Adorei minha terapia e pretendo continuar o tratamento. Muito obrigada, Dra. Elaine.',
    rating: 5,
  },
];

/* ======================
   ESTRELAS
====================== */
const Stars = ({ rating, size = '0.85rem' }) => (
  <div className="d-flex gap-1" aria-label={`${rating} de 5 estrelas`}>
    {[...Array(5)].map((_, i) => (
      <i
        key={i}
        className={`bi ${i < rating ? 'bi-star-fill' : 'bi-star'} text-warning`}
        style={{ fontSize: size }}
      />
    ))}
  </div>
);

/* ======================
   COMPONENTE PRINCIPAL
====================== */
export default function Depoimentos() {
  const [abertos, setAbertos] = useState([]);

  const alternar = (index) => {
    setAbertos((atual) =>
      atual.includes(index) ? atual.filter((i) => i !== index) : [...atual, index]
    );
  };

  return (
    <section
      className="py-5"
      id="depoimentos"
      aria-label="Experiências de pacientes em terapia psicológica"
      style={{ backgroundColor: '#f7f8f8' }}
    >
      <div className="container">

        {/* TOPO */}
        <div className="text-center mx-auto mb-4" style={{ maxWidth: '640px' }}>
          <h2 className="fw-bold text-marrom-suave mb-2">
            Experiências de pacientes
          </h2>
          <div className="d-flex align-items-center justify-content-center gap-2 mb-2">
            <Stars rating={5} size="1rem" />
            <span className="fw-semibold" style={{ color: '#1f4e5a' }}>5,0</span>
          </div>
          <p className="text-muted mb-0 small" style={{ lineHeight: '1.6' }}>
            Relatos de pacientes sobre o processo terapêutico, com identidade preservada
            e em conformidade com o Código de Ética Profissional.
          </p>
        </div>

        {/* GRADE */}
        <div className="row g-3 align-items-start">
          {depoimentos.map((dep, index) => (
            <article key={index} className="col-12 col-md-6 col-lg-4">
              <div
                className="d-flex flex-column p-3 rounded-4 bg-white"
                style={{
                  border: '1px solid rgba(31, 78, 90, 0.08)',
                  boxShadow: '0 4px 14px rgba(0,0,0,0.04)',
                }}
              >
                <p
                  className={`depoimento-texto text-muted mb-1 ${abertos.includes(index) ? 'aberto' : ''}`}
                >
                  <i
                    className="bi bi-quote me-1"
                    style={{ color: '#c47a5f', fontSize: '1em', lineHeight: 1 }}
                  />
                  {dep.texto}
                </p>

                {/* Espaço reservado mantém todos os cartões com a mesma altura */}
                <div className="mb-2" style={{ height: '1.5rem' }}>
                  {dep.texto.length > LIMITE_TEXTO && (
                    <button
                      type="button"
                      className="btn btn-link p-0 text-decoration-none"
                      style={{ color: '#1f6f66', fontSize: '0.9rem', fontWeight: 600, lineHeight: '1.5rem' }}
                      onClick={() => alternar(index)}
                      aria-expanded={abertos.includes(index)}
                    >
                      {abertos.includes(index) ? 'Ler menos' : 'Ler mais'}
                    </button>
                  )}
                </div>

                <div
                  className="d-flex align-items-center justify-content-between pt-2"
                  style={{ borderTop: '1px solid rgba(0,0,0,0.06)' }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center fw-semibold"
                      style={{
                        width: 30,
                        height: 30,
                        backgroundColor: '#1f4e5a',
                        color: '#fff',
                        fontSize: '0.8rem',
                      }}
                    >
                      {dep.nome}
                    </div>
                    <small className="text-muted">Paciente · {dep.ano}</small>
                  </div>
                  <Stars rating={dep.rating} />
                </div>
              </div>
            </article>
          ))}
        </div>

      </div>
    </section>
  );
}
